import ScrollReveal from '@/components/effects/ScrollReveal';
import { useLang } from '@/contexts/LanguageContext';

export default function Privacy() {
  const { lang } = useLang();
  const isAr = lang === 'ar';

  return (
    <div data-testid="privacy-page" className="min-h-screen py-20 md:py-32 px-4">
      <div className="max-w-3xl mx-auto">
        <ScrollReveal>
          <h1 className="text-4xl sm:text-5xl font-display text-heading mb-8">
            {isAr ? 'سياسة الخصوصية' : 'Privacy Policy'}
          </h1>
          <p className="text-text-muted text-sm font-body mb-12">
            {isAr ? 'آخر تحديث: أبريل 2026' : 'Last updated: April 2026'}
          </p>
        </ScrollReveal>

        <div className="prose-gravity font-body space-y-8">
          <ScrollReveal delay={0.05}>
            <section>
              <h2>{isAr ? 'من نحن' : 'Who We Are'}</h2>
              <p>{isAr
                ? 'TariqWithin هو منصة طارق أبو فياض الشخصية — للمحتوى والكتب والدورات والفعاليات. نحن نحترم خصوصيتك ونلتزم بحمايتها.'
                : 'TariqWithin is the personal brand platform of Tariq AbuFiad — for content, books, courses, and events. We respect your privacy and are committed to protecting it.'
              }</p>
            </section>
          </ScrollReveal>

          <ScrollReveal delay={0.1}>
            <section>
              <h2>{isAr ? 'المعلومات التي نجمعها' : 'Information We Collect'}</h2>
              <p><strong>{isAr ? 'معلومات الحساب:' : 'Account Information:'}</strong> {isAr ? 'عند التسجيل، نجمع بريدك الإلكتروني واسم المستخدم واسم العرض.' : 'When you register, we collect your email, username, and display name.'}</p>
              <p><strong>{isAr ? 'بيانات الشراء:' : 'Purchase Data:'}</strong> {isAr ? 'عند الشراء، نعالج الدفع عبر PayPal ونحتفظ بسجلات الطلبات.' : 'When you make a purchase, we process payment through PayPal and maintain order records.'}</p>
              <p><strong>{isAr ? 'ملفات تعريف الارتباط:' : 'Cookies:'}</strong> {isAr ? 'نستخدم ملفات تعريف الارتباط للتحقق من الهوية وتحليل حركة المرور وتحسين تجربتك.' : 'We use cookies for authentication, traffic analysis, and to improve your experience.'}</p>
              <p><strong>{isAr ? 'بيانات الموقع الجغرافي:' : 'Geolocation Data:'}</strong> {isAr ? 'نستخدم عنوان IP الخاص بك لتحديد عملتك المحلية (USD أو ILS) فقط.' : 'We use your IP address solely to detect your local currency (USD or ILS).'}</p>
              <p><strong>{isAr ? 'النشرة الإخبارية:' : 'Newsletter:'}</strong> {isAr ? 'إذا اشتركت في النشرة، نحتفظ ببريدك الإلكتروني لإرسال المحتوى ذي الصلة.' : 'If you subscribe to our newsletter, we store your email to send relevant content.'}</p>
            </section>
          </ScrollReveal>

          <ScrollReveal delay={0.15}>
            <section>
              <h2>{isAr ? 'كيف نستخدم معلوماتك' : 'How We Use Your Information'}</h2>
              <p>{isAr
                ? 'نستخدم المعلومات التي نجمعها لتوفير خدماتنا وتحسينها، ومعالجة المعاملات، والتواصل معك بشأن الطلبات والمحتوى الجديد، وتخصيص تجربتك.'
                : 'We use the information we collect to provide and improve our services, process transactions, communicate with you about orders and new content, and personalize your experience.'
              }</p>
            </section>
          </ScrollReveal>

          <ScrollReveal delay={0.2}>
            <section>
              <h2>{isAr ? 'مشاركة البيانات' : 'Data Sharing'}</h2>
              <p>{isAr
                ? 'لا نبيع بياناتك الشخصية. نشارك المعلومات فقط مع مزودي الخدمة الضروريين (PayPal للمدفوعات) وعند الاقتضاء بموجب القانون.'
                : 'We do not sell your personal data. We share information only with essential service providers (PayPal for payments) and when required by law.'
              }</p>
            </section>
          </ScrollReveal>

          <ScrollReveal delay={0.25}>
            <section>
              <h2>{isAr ? 'حقوقك' : 'Your Rights'}</h2>
              <p>{isAr
                ? 'لديك الحق في الوصول إلى بياناتك الشخصية أو تصحيحها أو حذفها. يمكنك إلغاء الاشتراك في النشرة الإخبارية في أي وقت. للطلبات المتعلقة بالبيانات، تواصل معنا على contact@tariqwithin.com.'
                : 'You have the right to access, correct, or delete your personal data. You can unsubscribe from the newsletter at any time. For data requests, contact us at contact@tariqwithin.com.'
              }</p>
            </section>
          </ScrollReveal>

          <ScrollReveal delay={0.3}>
            <section>
              <h2>{isAr ? 'اتصل بنا' : 'Contact Us'}</h2>
              <p>{isAr
                ? 'إذا كانت لديك أسئلة حول سياسة الخصوصية هذه، يرجى التواصل معنا:'
                : 'If you have questions about this privacy policy, please reach out:'
              }</p>
              <p><a href="mailto:contact@tariqwithin.com">contact@tariqwithin.com</a></p>
            </section>
          </ScrollReveal>
        </div>
      </div>
    </div>
  );
}
